import React from "react";

const GenderIcon = ({ color = "#0B65B5" }) => {
  return (
    <svg
      width="18"
      height="19"
      viewBox="0 0 18 19"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clipPath="url(#clip0_182_14081)">
        <path
          d="M16.9461 17.8572C16.4063 16.1741 15.346 14.7058 13.918 13.6641C12.49 12.6224 10.768 12.061 9.0004 12.061C7.2328 12.061 5.51085 12.6224 4.08282 13.6641C2.65479 14.7058 1.59446 16.1741 1.05469 17.8572H16.9461Z"
          stroke={color}
          strokeWidth="1.2"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M9.00071 12.0715C9.71525 12.0715 10.4228 11.9308 11.0829 11.6573C11.7431 11.3839 12.3429 10.9831 12.8482 10.4778C13.3534 9.97256 13.7542 9.37274 14.0277 8.71259C14.3011 8.05244 14.4419 7.34489 14.4419 6.63035C14.4419 5.91581 14.3011 5.20827 14.0277 4.54812C13.7542 3.88797 13.3534 3.28814 12.8482 2.78288C12.3429 2.27763 11.7431 1.87683 11.0829 1.60339C10.4228 1.32995 9.71525 1.18921 9.00071 1.18921C7.55763 1.18921 6.17366 1.76247 5.15324 2.78288C4.13283 3.8033 3.55957 5.18727 3.55957 6.63035C3.55957 8.07343 4.13283 9.45741 5.15324 10.4778C6.17366 11.4982 7.55763 12.0715 9.00071 12.0715Z"
          stroke={color}
          strokeWidth="1.2"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M10.7777 8.73508C10.7777 8.73508 10.3264 9.6235 9.00081 9.6235C7.67524 9.6235 7.22396 8.73636 7.22396 8.73636M14.343 5.59408H14.307C13.5557 5.59454 12.8129 5.4352 12.128 5.12664C11.443 4.81807 10.8315 4.36734 10.3341 3.80436C9.83652 4.3675 9.22482 4.81833 8.53963 5.1269C7.85443 5.43547 7.11143 5.59472 6.35996 5.59408C5.47379 5.59642 4.60134 5.37532 3.82324 4.95122C4.19641 3.80437 4.93987 2.81391 5.93689 2.13533C6.93392 1.45675 8.12806 1.12847 9.33185 1.20203C10.5356 1.2756 11.6809 1.74684 12.5879 2.54177C13.4949 3.3367 14.1122 4.41032 14.343 5.59408Z"
          stroke={color}
          strokeWidth="1.2"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </g>
      <defs>
        <clipPath id="clip0_182_14081">
          <rect
            width="18"
            height="18"
            fill="white"
            transform="translate(0 0.5)"
          />
        </clipPath>
      </defs>
    </svg>
  );
};

export default GenderIcon;
